document.addEventListener('DOMContentLoaded', () => {
    // Handle swatch clicks on product cards
    document.querySelectorAll('.product-card .swatch').forEach(swatch => {
        swatch.addEventListener('click', function(e) {
        e.preventDefault();
        const current_swatch = this;
        const card = this.closest('.product-card');
        const mediaId = this.dataset.mediaId;
        
        // Update active state on swatches
        card.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
        this.classList.add('active');

        // Update media display
        if (mediaId) {
            card.querySelectorAll('.product-media-item').forEach(item => {
            item.style.display = item.dataset.mediaId === mediaId ? 'block' : 'none';
            if (item.dataset.mediaId === mediaId) { item.classList.add('active') } else { item.classList.remove('active') }
            });
        }

        // Update quickview id
        card.querySelectorAll('quick-view').forEach(item => {
            item.setAttribute('data-variant-id', current_swatch.dataset.variantId);
        });
        });
    });
});
